import { createAction } from '@reduxjs/toolkit';

export const logoutStart = createAction('LOGOUT::START');
